import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

import type { Respondent } from '@/types/respondent';

/** Whether the respondent information is currently being saved to the API. */
export const isSavingRespondentAtom = atomWithReset<boolean>(false);

/** Whether the respondent object has changes that have not yet been saved to the API. */
export const hasUnsavedRespondentChangesAtom = atomWithReset<boolean>(false);

/** Atom storing the last error encountered when attempting to save the respondent. */
export const respondentErrorAtom = atomWithReset<Error | null>(null);

/** Return the id of the logged-in respondent. */
export const respondentIdAtom = atom<string | null>((get) => {
  const respondent: Respondent = get(respondentAtom);
  return respondent?.id ? respondent.id : null;
});

/** A respondent object containing their id, batch info, random seed, and unique login code value. */
export const respondentAtom = atomWithReset<Respondent>(
  {
    id: '',
    batch: '',
    completedAt: null,
    continent: '',
    country: '',
    createdAt: '',
    language: '',
    randomSeed: 0,
    startedAt: null,
    user: {
      id: '',
      accountUserRelations: [],
      createdAt: '',
      isEmailAddressVerificationRequired: false,
      isEmailAddressVerified: false,
      firstName: '',
      isActive: true,
      isStaff: false,
      lastName: '',
      respondents: [],
      url: ''
    }
  }
);